import React from 'react';
// import { useMakePHPRequest } from '../../../common/useMakePHPRequest';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';

export function DeleteIvrModal({
  setRefetchToggleForBusinessIvrs,
  enqueueSnackbarWithStyles,
  userAtom,
  selected,
  handleClose,
  show,
  mutation,
}) {
  // const makeRequest = useMakePHPRequest({
  //   userAtom: userAtom.contents,
  // });
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (values.selected.length) {
          for (let i = 0; i < values.selected.length; i++) {
            // const { response } = await makeRequest({
            //   methodName: methodNameEnum.DELETE_IVR,
            //   payload: {
            // ivrid: values.selected[i].mainIVRid,
            //   },
            // });
            const data = {
              call: methodNameEnum.DELETE_IVR,
              apikey: userAtom.contents.apikey,
              businessid: userAtom.contents.businessid,
              ivrid: values.selected[i].mainIVRid,
            };
            const response = await mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_IVR,
              payload: data,
            });
            if (!response?.data?.success) {
              enqueueSnackbarWithStyles({
                message:
                  'Looks like we encountered an error deleting these IVR(s)',
                alertProps: { severity: 'warning' },
              });
              break;
            }
          }
        }
        handleClose();
        enqueueSnackbarWithStyles({
          message: `Successfully Deleted ${values.selected.length} IVR(s)`,
          alertProps: { severity: 'success' },
        });
        setRefetchToggleForBusinessIvrs({});
        actions.resetForm({});
      }}
      enableReinitialize={true}
      initialValues={{
        selected: selected ?? [],
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete IVR(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              size="xs"
            >
              <p>
                You are about to delete {formik.values.selected.length} selected
                IVR(s),
              </p>
              <p>this procedure is not reversible. Do you want to proceed?</p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
